import React from 'react'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import Paper from '@mui/material/Paper'
import QRCode from 'qrcode.react'
import { useTranslation } from 'react-i18next'
import { emptyImage } from '../../images'
import { useNavigate } from 'react-router-dom'
import { formatDate } from '../../helpers/utils'

interface QRDataItem {
  color?: string
  logo?: string
}

interface TableDataItem {
  _id: string
  title: string
  createdAt: string
  short_url: string
  qr_code: QRDataItem
  url: string
  domain: string
  clicks: number
}

interface TableListProps {
  dataBody: TableDataItem[] | undefined
  isQrList?: boolean
  elevation?: number
  url: string
}

const TableList = ({
  dataBody,
  isQrList = false,
  elevation = 1,
  url,
}: TableListProps) => {
  const { t } = useTranslation()

  let navigate = useNavigate()

  const goTo = (url: string) => {
    navigate(url)
  }
  return (
    <>
      <Paper elevation={elevation} className='table m-0 p-0'>
        <TableContainer className='table-container'>
          <Table stickyHeader aria-label='sticky table' id='table-to-xls'>
            <TableBody>
              {dataBody && dataBody.length > 0 ? (
                dataBody.map((value, index) => (
                  <TableRow
                    key={value._id}
                    className='table-row-link'
                    onClick={() => goTo(`${url}${value._id}`)}
                  >
                    <TableCell>
                      {isQrList && value.qr_code ? (
                        <div className='container-qr-list'>
                          {value.qr_code?.logo ? (
                            <QRCode
                              value={value.short_url}
                              fgColor={value.qr_code.color}
                              size={40}
                              bgColor='transparent'
                              level='H'
                              imageSettings={{
                                src: value.qr_code.logo,
                                height: 12,
                                width: 12,
                                excavate: true,
                              }}
                            />
                          ) : (
                            <QRCode
                              value={value.short_url}
                              fgColor={value.qr_code.color}
                              size={40}
                              bgColor='transparent'
                              level='H'
                            />
                          )}
                        </div>
                      ) : (
                        <img
                          src={value.qr_code?.logo || emptyImage}
                          alt={`${t('LOGO')}`}
                          height={30}
                          width={30}
                        />
                      )}
                    </TableCell>
                    <TableCell>{value.title}</TableCell>
                    <TableCell>{value.short_url}</TableCell>
                    <TableCell>{formatDate(value.createdAt)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>{t('NO_DATA')}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}

export default TableList
